/* eslint-disable jsx-a11y/alt-text */
// eslint-disable-next-line no-unused-vars
import FeatherIcon from 'feather-icons-react'
import { api } from '../../services/api'
import { useContext, useEffect } from 'react'
import MyContext from '../../contexts/myContext'
import styles from "./stylesBarraTitulo.module.css"

export function BarraTitulo(props) {

    const { user, addTab } = useContext(MyContext)

    useEffect(() => {
       // document.getElementById(`imgPreview_${props?.Name}`).src = `${api.defaults.baseURL}/api/getLogoEmpresa/${user?.cnpj}`
    }, [])


    function showHelp() {
        addTab('AJUDA - ' + props.Name.toUpperCase())
    }

    return (
        <>
            <div>
                <h1 className='  h-28 ultraWide:h-32 pt-4 pl-6 text-lg md:text-2xl xl:text-3xl 2xl:text-4xl ultraWide:text-5xl bg-gradient-to-r from-slate-900 to-slate-700 text-white-100 font-bold p-2 flex justify-between'>
                    {props.Name.toUpperCase()}
                    <img id={`imgPreview_${props?.Name}`} className="select-none h-12 mt-[-0.5rem] lg:h-14 2xl:h-16 ultraWide:h-20 pr-6 ultraWide:pr-8" src="LogoDashboard.png" />
                </h1>
                <div className={`${styles.tasks} ${props.showTasks ? '' : 'hidden'} mt-[-2rem] rounded-lg h-[3rem] mx-6 bg-white-100`}>
                    <div className="flex flex-row w-full h-full">
                        <div className={`${props.new ? 'flex' : 'hidden'} items-center justify-center border-r border-gray-200 transition duration-[400ms] cursor-pointer hover:border-b-[2.5px] hover:rounded-l-lg hover:border-b-blue-400 h-full w-[14.28571428571429%]`}>
                            <FeatherIcon className={'text-gray-500'} icon={'file-plus'} />
                        </div>
                        <div className={`${props.search ? 'flex' : 'hidden'} items-center justify-center border-r border-gray-200 transition duration-[400ms] cursor-pointer hover:border-b-[2.5px] hover:border-b-blue-400 h-full w-[14.28571428571429%]`}>
                            <FeatherIcon className={'text-gray-500'} icon={'search'} />
                        </div>
                        <div className={`${props.save ? 'flex' : 'hidden'} items-center justify-center border-r border-gray-200 transition duration-[400ms] cursor-pointer hover:border-b-[2.5px] hover:border-b-blue-400 h-full w-[14.28571428571429%]`}>
                            <FeatherIcon className={'text-gray-500'} icon={'save'} />
                        </div>
                        <div onClick={() => props.ExportarPage()} className={`${props.printer ? 'flex' : 'hidden'} items-center justify-center border-r border-gray-200 transition duration-[400ms] cursor-pointer hover:border-b-[2.5px] hover:border-b-blue-400 h-full w-[14.28571428571429%]`}>
                            <FeatherIcon className={'text-gray-500'} icon={'printer'} />
                        </div>
                        <div className={`${props.clean ? 'flex' : 'hidden'} items-center justify-center border-r border-gray-200 transition duration-[400ms] cursor-pointer hover:border-b-[2.5px] hover:border-b-blue-400 h-full w-[14.28571428571429%]`}>
                            <FeatherIcon className={'text-gray-500'} icon={'monitor'} />
                        </div>
                        <div className={`${props.delete ? 'flex' : 'hidden'} items-center justify-center border-r border-gray-200 transition duration-[400ms] cursor-pointer hover:border-b-[2.5px] hover:border-b-blue-400 h-full w-[14.28571428571429%]`}>
                            <FeatherIcon className={'text-gray-500'} icon={'trash-2'} />
                        </div>
                        <div className='flex justify-end w-full'>
                            <div onClick={() => showHelp()} className="flex items-center justify-center border-l border-gray-200 transition duration-[400ms] cursor-pointer hover:border-b-[2.5px] hover:rounded-r-lg hover:border-b-blue-400 h-full w-[14.28571428571429%]">
                                <FeatherIcon className={'text-gray-500'} icon={'help-circle'} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}
